// ConditionTree.jsx
import React, { useCallback, useEffect, useState } from "react";
import './TreeNode.css';
import { UserPicture } from "../../../common/UserPicker/UserPicture";

const TreeNode = ({ node, isFirst, parent }) => {
    return (
        <div className={`tree ${parent <= 2 ? "No-Borders" : ""}`}>
            {node.label!=="" &&
            <div className={`${isFirst?"d-none":''} node`}>
                {!isFirst && <div className="connector"></div>}
                {!isFirst && node.condition && <span className="condition">{node.condition}</span>}

                <span className="text">
                    {node.label} <span className="highlight">{node.midCondition} </span>
                    <strong>{node.status}</strong>
                </span>
            </div>}
            

            {node.children && (
                <div className="tree">
                    {node.children.map((child, index) => (
                        <TreeNode key={index} parent={parent + 1} node={child} isFirst={false} />
                    ))}
                </div>
            )}
        </div>
    );
};

const ConditionTree = ({ criteria, criteriaFieldGroups, taskFlow, allRoles }) => {
    const [data, setData] = useState({});
    console.log("data",data);
    
    const getLastData = (row) => {
        if (row.group === "Input Fields") {
            if (["PICKLIST", "MULTI-PICKLIST"].includes(row.type)) {
                let temp = criteriaFieldGroups["Input Fields"]?.find(k => k.id === row.initial);
                if (row.last && Array.isArray(row.last)) {
                    let str = temp?.ExtraData?.filter(k => row.last.includes(k.id))?.map(m => m.text).join(",");
                    return <div title={str} style={{ width: "12em" }} className="d-flex Elipsis-Class">{str}</div>
                } else {
                    return temp?.ExtraData?.find(k => row.last === k.id)?.text;
                }
            } else if (row.type === "USER") {
                return row.last && Array.isArray(row.last)
                    ? <div className="d-flex">{row.last.map(a => <UserPicture key={a} values={a} />)}</div>
                    : <UserPicture key={row.last} values={row.last} />
            } else if (row.type === "ROLE") {
                let role = allRoles?.find(k => k.ROWID === row.last);
                return role ? role.RoleName : row.last;
            }
        } else if (row.group === "Task") {
            if (row.type === "USER") {
                return row.last && Array.isArray(row.last)
                    ? <div className="d-flex">{row.last.map(a => <UserPicture key={a} values={a} />)}</div>
                    : <UserPicture key={row.last} values={row.last} />
            }
        } else if (["BOOLEAN", "CHECKBOX"].includes(row.type)) {
            return row.last === 1 ? "True" : "False";
        } else if (["USER"].includes(row.type)) {
            if (row.last && Array.isArray(row.last)) {
                let str = row.last.map(a => a).join(",");
                return <div title={str} style={{ width: "12em" }} className="d-flex Elipsis-Class">{str}</div>
            } else {
                return row.last;
            }
        }
        return row.last;
    };

    useEffect(() => {
        if (criteria && criteriaFieldGroups) {
            const buildTree = (item) => {
                if (item.Group) {
                    let children = item.Group.map(sub => buildTree(sub));
                    return {
                        label: criteriaFieldGroups[item.group]?.find(k =>
                            item.group === "Input Fields" ? k.id === item.initial : k.field === item.initial
                        )?.[item.group === "Input Fields" ? "Name" : "label"] || "",
                        midCondition: item.middel,
                        status: getLastData(item),
                        condition: item.condition,
                        children
                    };
                } else {
                    return {
                        label: criteriaFieldGroups[item.group]?.find(k =>
                            item.group === "Input Fields" ? k.id === item.initial : k.field === item.initial
                        )?.[item.group === "Input Fields" ? "Name" : "label"] || "",
                        midCondition: item.middel,
                        status: getLastData(item),
                        condition: item.condition,
                    };
                }
            };

            const treeData = buildTree({
                Group: criteria,
                group: criteria[0]?.group,
                middel: criteria[0]?.middel,
                initial: criteria[0]?.initial,
                condition: criteria[1]?.condition || "",
                last: criteria[0]?.last,
                type: criteria[0]?.type
            });

            setData(treeData);
        }
    }, [criteria, criteriaFieldGroups]);

    const getTreeData = useCallback(() => {
        return <TreeNode node={data} parent={1} isFirst={true} />;
    }, [data]);

    return (
        <div className="criteria-container">
            {getTreeData()}
        </div>
    );
};

export default ConditionTree;